import React from "react";

const AnimaticScrollingSkeleton: React.FC = () => {
  const totalCols = 4;
  const perCol = 3; // Assuming 3 items per column for consistent skeleton placeholders
  const skeletonCols = Array.from({ length: totalCols }, (_, i) => ({
    index: i + 1,
    className: `${i === 1 ? "max-lg:col-span-3" : i === totalCols - 1 ? "max-lg:hidden" : "max-lg:col-span-2"}`,
  }));

  return (
    <div className="max-w-full h-fit flex items-center justify-center overflow-hidden relative">
      <div
        className="absolute bg-background inset-0 z-30 w-full h-8"
        style={{ borderRadius: "0 0 40% 40% / 0 0 40% 40%" }}
      ></div>

      <div className="grid grid-cols-7 lg:grid-cols-4 gap-4 max-sm:min-w-[calc(100%+50px)] max-lg:min-w-[calc(100%+100px)]">
        {skeletonCols.map((col, i) => (
          <div
            key={i}
            className={`flex flex-col gap-4 animate-pulse ${col.className}`}
          >
            {Array.from({ length: perCol }).map((_, idx) => (
              <div
                key={idx}
                className="w-full h-48 bg-gray-200 rounded-lg shadow-sm"
              ></div>
            ))}
          </div>
        ))}
        <div className="absolute top-0 left-0 w-full h-full bg-gray-200 animate-pulse" />
      </div>
    </div>
  );
};

export default AnimaticScrollingSkeleton;